import { FieldTypes } from '@features/campaigns/builder/components/FormFields/FieldTypes.ts';
import {
  HIGH_IMPACT_CREATIVE_FORMAT_LIST,
  HIGH_IMPACT_CREATIVE_FORMATS,
} from '@features/campaigns/builder/consts/highImpactCreativeFormats.ts';
import {
  RestoredStep03ThematicPackagesData,
  Step03ThematicPackagesFormValues,
  UpdateHighImpactAdProductPayload,
} from '@features/campaigns/builder/containers/FormPages/Step03ThematicPackages/Step03ThematicPackages.types.ts';
import {
  isNewHighImpactCreativeFile,
  step03ThematicPackagesDefaultValues,
} from '@features/campaigns/builder/hooks/Step03/step03ThematicPackages.helpers.ts';
import { HighImpactCreativePayload } from '@features/campaigns/builder/services/campaign/uploadHighImpactCreative.ts';
import { CampaignDetails, HighImpactCreativeType } from '@features/campaigns/shared/types/campaign.ts';

export interface HighImpactCreativeUpload {
  type: HighImpactCreativeType;
  payload: HighImpactCreativePayload;
}

export function updateHighImpactAdProductDTO(
  formValues: Step03ThematicPackagesFormValues,
): UpdateHighImpactAdProductPayload {
  return {
    landingPageUrl: formValues.landingPageUrl || undefined,
    [FieldTypes.INTRO_MOBILE_CONTAINS_POLITICAL_CONTENT]:
      formValues[FieldTypes.INTRO_MOBILE_CONTAINS_POLITICAL_CONTENT],
    [FieldTypes.MASTHEAD_CONTAINS_POLITICAL_CONTENT]: formValues[FieldTypes.MASTHEAD_CONTAINS_POLITICAL_CONTENT],
    [FieldTypes.MASTHEAD_ADAPTIVE_CONTAINS_POLITICAL_CONTENT]:
      formValues[FieldTypes.MASTHEAD_ADAPTIVE_CONTAINS_POLITICAL_CONTENT],
    [FieldTypes.SKIN_CONTAINS_POLITICAL_CONTENT]: formValues[FieldTypes.SKIN_CONTAINS_POLITICAL_CONTENT],
  };
}

export function uploadHighImpactCreativesDTO(formValues: Step03ThematicPackagesFormValues): HighImpactCreativeUpload[] {
  return HIGH_IMPACT_CREATIVE_FORMAT_LIST.flatMap(({ type, fieldName, politicalContentFieldName }) => {
    const value = formValues[fieldName];

    return isNewHighImpactCreativeFile(value)
      ? [{ type, payload: { file: value[0], containsPoliticalContent: formValues[politicalContentFieldName] } }]
      : [];
  });
}

export function restoreStep03ThematicPackagesDataDTO(data: CampaignDetails): RestoredStep03ThematicPackagesData {
  const formData: Step03ThematicPackagesFormValues = {
    ...step03ThematicPackagesDefaultValues,
    [FieldTypes.LANDING_PAGE_URL]: data.adProductHighImpact?.landingPageUrl || undefined,
  };

  data.adProductHighImpact?.creatives.forEach(({ type, url, containsPoliticalContent }) => {
    const format = HIGH_IMPACT_CREATIVE_FORMATS[type];

    if (!format) {
      return;
    }

    formData[format.fieldName] = url;
    formData[format.politicalContentFieldName] = containsPoliticalContent;
  });

  return {
    formData,
    isAdProductSaved: Boolean(data.adProductHighImpact),
    invalidSections: data.invalidSections,
    status: data.status,
  };
}
